import { render, staticRenderFns } from "./main-section-reports-detail.vue?vue&type=template&id=4ab62a17&scoped=true"
import script from "./main-section-reports-detail.vue?vue&type=script&lang=js"
export * from "./main-section-reports-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab62a17",
  null
  
)

export default component.exports